import { FilterOption } from '../../../components/_WMS/FilterComponent/types'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../../types/filters'
import { SupplierAutoCompleter } from '../components/SupplierAutoCompleter'

export const filterOptions: FilterOption[] = [
  {
    key: 'supplierId',
    label: 'Proveedor',
    type: 'custom',
    Component: SupplierAutoCompleter,
    order: 1,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    key: 'rutDniSupplier',
    label: 'RUT/DNI',
    type: 'text',
    order: 3
  },
  {
    key: 'active',
    label: 'Activo',
    type: 'precreated',
    order: 4
  },
  {
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated',
    order: 5
  }
]
